import { useState } from "react";
import { Link } from "react-router-dom";
import BrandShell from "../components/BrandShell";
import { apiCall } from "../auth/AuthContext";
import { ArrowRight, Loader2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState({ status: "idle", message: "" });

  const onSubmit = async (e) => {
    e.preventDefault();
    setState({ status: "loading", message: "" });
    try {
      const res = await apiCall("/api/auth/forgot-password", { method: "POST", body: JSON.stringify({ email: email.trim() }) });
      setState({ status: "success", message: res?.message || "If an account exists for that email, we sent reset instructions." });
    } catch (err) {
      setState({ status: "error", message: err.message || "Something went wrong." });
    }
  };

  return (
    <BrandShell dashboardChrome>
      <section data-testid="forgot-page" className="relative bg-jc-black text-jc-white min-h-[calc(100vh-5rem)] flex items-center overflow-hidden">
        <div className="absolute inset-0 jc-grid-bg" />
        <div className="relative z-10 mx-auto w-full max-w-md px-6 md:px-10 py-16">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-jc-gold text-center mb-3">◆ Password Reset</p>
          <h1 className="font-display text-jc-white text-center" style={{ fontSize: "clamp(2rem, 4.5vw, 3rem)", lineHeight: 0.95 }}>
            FORGOT <span className="text-jc-gold">PASSWORD?</span>
          </h1>
          <p className="mt-5 font-body text-jc-muted text-center">
            Enter your email and we'll send you a link to reset it.
          </p>

          <form onSubmit={onSubmit} className="mt-10 space-y-6" data-testid="forgot-form">
            <div>
              <label className="font-mono text-[10px] uppercase tracking-[0.28em] text-jc-gold">Email</label>
              <input
                data-testid="forgot-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-transparent border-b border-jc-gold/30 px-0 py-3 font-body text-base text-jc-white placeholder-jc-muted focus:border-jc-gold focus:outline-none"
                placeholder="you@example.com"
              />
            </div>
            <button
              type="submit"
              disabled={state.status === "loading"}
              data-testid="forgot-submit"
              className="jc-btn jc-btn-primary w-full !py-4 disabled:opacity-60"
            >
              {state.status === "loading" ? (
                <><Loader2 size={16} className="animate-spin" /> SENDING...</>
              ) : (
                <>SEND RESET LINK <ArrowRight size={16} strokeWidth={2.5} /></>
              )}
            </button>
            {state.status === "success" && (
              <div data-testid="forgot-success" className="font-mono text-xs uppercase tracking-[0.2em] text-jc-gold-light text-center">{state.message}</div>
            )}
            {state.status === "error" && (
              <div data-testid="forgot-error" className="font-mono text-xs uppercase tracking-[0.2em] text-red-400 text-center">{state.message}</div>
            )}
          </form>
          <p className="mt-10 text-center"><Link to="/dashboard" className="font-mono text-xs uppercase tracking-[0.25em] text-jc-muted hover:text-jc-gold">← Back to sign in</Link></p>
        </div>
      </section>
    </BrandShell>
  );
}
